import { useNavigate } from "react-router-dom";
import "./CartProductSelection.css";

const CartProductSelect = ({
  items,
  selectedStatus,
  combo,
  handleComboTotalChange,
  handleTotalChange,
  comboCart,
  comboSelected,  
  handleRemoveItem,
  uom
}) => {
  const navigate = useNavigate();
  return (
    <div className="products-group-header"  >
      <div style={{justifyContent: "space-between" ,width: "100%"}}>
       <div  className="combo-name" style={{fontWeight: "bold" ,marginLeft: "30px",marginBottom: "5px",fontSize: "16px"}}>
        {items?.combo
          ?  items?.variants[0]?.name
            ?.split("/")[0]
            .trim()
          : items[0].articleName}</div>
      <div className="flex-row items-center" style={{display: "flex" ,justifyContent: "space-between" ,width: "100%"}}>
        <div className="flex-row-int" style={{display: "flex"}}>
        <input
          type="checkbox"
          className="app-checkbox flex-wrap m-r-8"
          checked={
            items?.combo
              ? comboSelected?.some(
                  (selectedItem) => selectedItem.combo.id === items.combo.id
                )
              : selectedStatus(items)
          }
          onChange={(event) =>
            items?.combo
              ? handleComboTotalChange(items, event)
              : handleTotalChange(items, event)
          }
          disabled={
            !items?.combo
              ? items.every(
                  (item) =>
                    item.published === "false" ||
                    (!item.backOrder && item.outOfStock) ||
                    item?.comboVariants?.includes(item.variantSku)
                )
              : !(items.variants.length > 0) || (!items.backOrder && items.outOfStock)
          }
        />
        <a
          className="text-underline cursor-pointer"
          onClick={() => {
            if (
              !items?.combo &&
              items.every((item) => item.published === "true")
            ) {
              navigate(items[0].pimUrl);
            } else if (items?.combo && items.combo.pimUrl) {
              navigate(items.combo.pimUrl);
            }
          }}
        >
          {items?.combo ? items.combo.articleCode : items[0].articleCode}
        </a>
        {!items?.combo && items.every((item) => item.published === "false") ? (
          <p style={{ color: "red", marginLeft: ".5rem" }}>
            {" "}
            (Product unavailable)
          </p>
        ) : (
          ""
        )}
        </div>
        {items?.combo && (
            <div
              className="text-nowrappcp"
            >
              {/* <div className="cart-product-weight" style={{fontWeight: "bold"}} >
                {items.combo.quantity * items?.variants?.length} {uom[ items?.variants[0]?.variantSku]}{" "}
              </div> */}
              <div className="cart-product-price-weight">
                {/* <div className="price-row">
                  <div className="f-600 flex-wrap">
                    &#8377;
                    {(
                      items.combo.quantity *
                      items?.variants?.length *
                      items.combo.sellingPrice
                    ).toFixed(2)}
                  </div>
                  <div className="c-gray-500 f-12 flex-wrap">
                    &#8377;{(items?.combo.sellingPrice).toFixed(2)}/{uom[ items?.variants[0]?.variantSku]}
                  </div>
                </div> */}
                <div
                className="cart-item-function-compo"
                onClick={() => handleRemoveItem(items)}
              >
                Remove
              </div>
            
              </div>
            
             
            </div>
        )}
      </div>
      </div>
    </div>
  );
};

export default CartProductSelect;
